import { render } from "./App.vue?vue&type=template&id=2234e18a"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=2234e18a&lang=css"

import exportComponent from "C:\\Users\\sun\\Desktop\\access_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__